// Globals
import { useTranslation } from 'react-i18next';

// Components
import { Button } from '@/ui';
import { NotFoundIcon } from '@/icons';
import Result from '../../components/Result';
import { StyledButtons } from './NotFoundStyles';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/models/router.model';

const NotFound = () => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();
  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const goHome = useCallback(() => {
    navigate(ROUTES.DASHBOARD);
  }, [navigate]);

  return (
    <Result title={t('error_not_found_title')} image={<NotFoundIcon />}>
      <StyledButtons>
        <Button onClick={goBack}>{t('error_not_found_go_back')}</Button>
        <Button onClick={goHome} type={'primary'}>
          {t('error_not_found_go_home')}
        </Button>
      </StyledButtons>
    </Result>
  );
};

export default NotFound;
